import axios from "axios";

export const state = {
    withdraws: [],
};

export const getters = {
    withdraws: state => state.withdraws,
};

export const mutations = {
    setWithdraws(state, newValue) {
        state.withdraws = newValue
    },
};

export const actions = {
    async fetchWithdraws({ commit }) {
        await axios.get('/withdraws').then(res => {
            commit('setWithdraws', res.data.withdraws)
        })
    },
    async filterWithdraws({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterwithdraws";
        await axios.post(url, formData).then((response) => {
            commit('setWithdraws', response.data.withdraws)
        })
    },
};
